module.exports = __webpack_public_path__ + "media/stylesheets/images/marker-icon-2x-blue-69c430ad6356dc863fc86a6a7b9bcb00.png";